'use strict';
import * as $j_app$002elocalization$002e$002dApp$002dLocale$0024 from "./app.localization.-App-Locale$.js";
import * as $j_app$002elocalization$002epackage$0024 from "./app.localization.package$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShipperNameForm$() {
  this.aR3 = null;
  this.aRk = null;
  this.aR6 = null;
  this.aR7 = false;
  this.aRc = null;
  this.aRd = false;
  this.aRi = null;
  this.aRj = false;
  this.aR4 = null;
  this.aR5 = false;
  this.aRg = null;
  this.aRh = false;
  this.aRe = null;
  this.aRf = false;
  this.aR8 = null;
  this.aR9 = false;
  this.aRa = null;
  this.aRb = false;
  $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShipperNameForm$ = this;
  this.aR3 = $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShipperName$();
  this.aRk = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_prelude_neotype\uff3fchimney$package$().eU($m_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShipperName$());
}
export { $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShipperNameForm$ as $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShipperNameForm$ };
$p = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShipperNameForm$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShipperNameForm$;
/** @constructor */
function $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShipperNameForm$() {
}
export { $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShipperNameForm$ as $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShipperNameForm$ };
$h_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShipperNameForm$.prototype = $p;
$p.eR = (function() {
  return this.aR3;
});
$p.eO = (function() {
  return this.aRk;
});
$p.bW = (function() {
  if ((!this.aR7)) {
    this.aR6 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_CanEqual$derived$();
    this.aR7 = true;
  }
  return this.aR6;
});
$p.b9 = (function() {
  if ((!this.aRd)) {
    this.aRc = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$1(this);
    this.aRd = true;
  }
  return this.aRc;
});
$p.b3 = (function() {
  if ((!this.aRj)) {
    this.aRi = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$5(this);
    this.aRj = true;
  }
  return this.aRi;
});
$p.aG = (function() {
  if ((!this.aR5)) {
    this.aR4 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$6(this);
    this.aR5 = true;
  }
  return this.aR4;
});
$p.az = (function() {
  if ((!this.aRh)) {
    this.aRg = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_UnvalidatedNewtypeOf__partialTransformer__Lio_scalaland_chimney_PartialTransformer(this);
    this.aRh = true;
  }
  return this.aRg;
});
$p.aY = (function() {
  if ((!this.aRf)) {
    this.aRe = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_utils_Validatable$().eS(this.az());
    this.aRf = true;
  }
  return this.aRe;
});
$p.afm = (function() {
  if ((!this.aR9)) {
    this.aR8 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_localization_LocalizationSupport$$anon$5(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((x$1) => {
      var x = $j_app$002elocalization$002e$002dApp$002dLocale$0024.$s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale();
      if (((x === null) ? (x$1 === null) : (x === x$1))) {
        return "Shipper";
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    })), $j_app$002elocalization$002epackage$0024.$m_Lapp_localization_package$().cN());
    this.aR9 = true;
  }
  return this.aR8;
});
$p.bNJ = (function() {
  if ((!this.aRb)) {
    this.aRa = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_components_TextKindFor$().jx;
    this.aRb = true;
  }
  return this.aRa;
});
var $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShipperNameForm$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShipperNameForm$, "app.data.data_point_types$package$ShipperNameForm$", ({
  Gu: 1,
  N: 1
}));
export { $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShipperNameForm$ as $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShipperNameForm$ };
var $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShipperNameForm$;
function $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShipperNameForm$() {
  if ((!$n_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShipperNameForm$)) {
    $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShipperNameForm$ = new $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShipperNameForm$();
  }
  return $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShipperNameForm$;
}
export { $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShipperNameForm$ as $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShipperNameForm$ };
/** @constructor */
function $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShipperName$() {
  this.aR1 = null;
  this.aR2 = false;
  this.aQZ = null;
  this.aR0 = false;
}
export { $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShipperName$ as $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShipperName$ };
$p = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShipperName$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_Lneotype_Newtype();
$p.constructor = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShipperName$;
/** @constructor */
function $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShipperName$() {
}
export { $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShipperName$ as $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShipperName$ };
$h_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShipperName$.prototype = $p;
$p.aA = (function() {
  if ((!this.aR2)) {
    this.aR1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_NewtypeString$$anon$1(this);
    this.aR2 = true;
  }
  return this.aR1;
});
$p.bNi = (function() {
  if ((!this.aR0)) {
    this.aQZ = $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShipperNameForm$().afm();
    this.aR0 = true;
  }
  return this.aQZ;
});
$p.ez = (function(input) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NewtypeNonEmptyString__validate__T__O(this, input);
});
var $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShipperName$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShipperName$, "app.data.data_point_types$package$ShipperName$", ({
  Gt: 1,
  B: 1,
  C: 1,
  J: 1,
  M: 1
}));
export { $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShipperName$ as $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShipperName$ };
var $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShipperName$;
function $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShipperName$() {
  if ((!$n_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShipperName$)) {
    $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShipperName$ = new $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShipperName$();
  }
  return $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShipperName$;
}
export { $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShipperName$ as $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$ShipperName$ };
//# sourceMappingURL=app.data.data_point_types$package$-Shipper-Name$.js.map
